import { Button } from '@/components/elements/forms/buttons';
import Icon from '@/components/icons/Icon';
import { _t } from '@/locale';

const baseTranslationKey = 'features.deals.components.NoSearchResults' as const;

const NoSearchResults = ({
  keyword,
  location,
  onCTAClick,
}: {
  keyword?: string;
  location?: string;
  onCTAClick?: () => void;
}) => {
  return (
    <section className="p-2xl bg-surface_l2 border-border_regular gap-xl flex flex-col justify-between rounded-md border md:flex-row md:items-center">
      <div className="space-y-xs flex flex-col">
        <h3 className="text-fg_primary text-h-m font-bold">{_t(`${baseTranslationKey}.title`)}</h3>
        <p className="text-fg_secondary text-l">
          {_t(`${baseTranslationKey}.description`, {
            keyword: keyword || _t('BeautyAndHealth'),
            location: location || _t('AllSweden'),
            interpolation: { escapeValue: false },
          })}
        </p>
      </div>

      <Button
        className="flex-shrink-0"
        variant="primary"
        size="lg"
        leftIcon={<Icon variant="search" />}
        onClick={onCTAClick}>
        {_t(`${baseTranslationKey}.cta`)}
      </Button>
    </section>
  );
};

export default NoSearchResults;
